import { css } from "@emotion/react";

import { BUTTON_SIZES, SideIconButtonProps } from "./types";

const IconRightButton = ({ title, icon, size }: SideIconButtonProps) => {
    return (
        <>
            {title}

            <span
                css={css({
                    display: "flex",
                    alignItems: "center",
                    marginLeft: size === BUTTON_SIZES.Tiny ? "4px" : "8px"
                })}
            >
                {icon}
            </span>
        </>
    );
};

export default IconRightButton;
